import { Component, Input } from '@angular/core';

@Component({
  selector: 'bpc-dynamic-skeleton-loader',
  templateUrl: './dynamic-skeleton-loader.component.html',
  styleUrls: ['./dynamic-skeleton-loader.component.scss']
})
export class DynamicSkeletonLoaderComponent {
  @Input() numberOfSkeletons: number|undefined = 5; // default to 5 skeletons
}